<template>
    <div class="filter-date-range">
        <!-- 开始日期 -->
        <DatePicker
            style="width: 140px"
            :value="innerStartDate"
            transfer
            type="date"
            placeholder="开始日期"
            :options="startDateOption"
            @input="onStartInput"
            @on-change="onStartChange"
        ></DatePicker>
        <span style="padding: 0 10px">至</span>
        <!-- 结束日期 -->
        <DatePicker
            style="width: 140px"
            :value="innerEndDate"
            transfer
            type="date"
            placeholder="结束日期"
            :options="endDateOption"
            @input="onEndInput"
            @on-change="onEndChange"
        ></DatePicker>
        <!-- 快速选择 -->
        <Select
            style="width: 140px; margin-left: 5px"
            transfer
            placeholder="快速选择"
            v-model="fastDate"
            @on-change="onFastChange"
        >
            <Option
                v-for="item in fastDateList"
                :value="item.id"
                :key="item.id"
            >
                {{ item.text }}
            </Option>
        </Select>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { toDateYmd, ymd } from '_u/helper'

// 日期区间选择
export default {
    name: 'FilterDateRange',

    props: {
        // 开始日期
        startDate: {
            type: [String, Number, Date],
            default: '',
        },
        // 结束日期
        endDate: {
            type: [String, Number, Date],
            default: '',
        },
        // 快捷选择日期
        quickDate: {
            type: [String, Number],
            default: '',
        },
    },

    data() {
        return {
            fastDateList: [
                { id: 7, text: '前7天' },
                { id: 30, text: '前30天' },
                { id: 90, text: '前90天' },
                { id: -7, text: '后7天' },
                { id: -30, text: '后30天' },
                { id: -90, text: '后90天' },
            ],
            fastDate: [],
            startDateOption: {
                disabledDate: (date) => {
                    if (this.innerEndDate === '') {
                        return false
                    } else if (date.getTime() > this.innerEndDate.getTime()) {
                        return true
                    }
                },
            },
            endDateOption: {
                disabledDate: (date) => {
                    if (this.innerStartDate === '') {
                        return false
                    } else if (this.innerStartDate.getTime() > date.getTime()) {
                        return true
                    }
                },
            },
        }
    },

    computed: {
        innerStartDate() {
            return this.startDate ? toDateYmd(this.startDate) : ''
        },
        innerEndDate() {
            return this.endDate ? toDateYmd(this.endDate) : ''
        },
    },

    methods: {
        onStartInput(val) {
            this.$emit('update:startDate', ymd(val))
        },

        onEndInput(val) {
            this.$emit('update:endDate', ymd(val))
        },

        // 日期更改
        onStartChange(val) {
            this.fastDate = ''
            this.$emit('on-change', {
                startDate: val,
                endDate: this.innerEndDate,
            })
        },

        onEndChange(val) {
            this.fastDate = ''
            this.$emit('on-change', {
                startDate: this.innerStartDate,
                endDate: val,
            })
        },

        onFastChange(el) {
            if (el) {
                if (el > 0) {
                    var startVal = dayjs().subtract(el, 'day'),
                        endVal = dayjs()
                } else {
                    var startVal = dayjs(),
                        endVal = dayjs().subtract(el, 'day')
                }

                this.$emit('update:startDate', startVal.format('YYYY-MM-DD'))
                this.$emit('update:endDate', endVal.format('YYYY-MM-DD'))
                this.$emit('on-change', {
                    startDate: startVal.toDate(),
                    endDate: endVal.toDate(),
                })
            }
        },
    },
}
</script>

<style lang="less" scoped>
.filter-date-range {
    display: inline-block;
}
</style>
